import React from 'react'

import { Box } from '~/components/elements/Box'
import { type FigureInfo, figureInfoKeys } from '~/utils'

import { FigureInfoRow } from './FigureInfoRow'
import styles from './FigureInfoTable.css'

export type FigureInfoTableProps = {
  'data-testid'?: string
  figureInfo: FigureInfo
}

export const FigureInfoTable = ({
  'data-testid': dataTestId = 'components-features-figure-info-table',
  figureInfo,
}: FigureInfoTableProps) => (
  <Box className={styles.root} data-testid={dataTestId}>
    {figureInfoKeys.map((figureInfoKey) => (
      <FigureInfoRow
        key={figureInfoKey}
        figureInfo={figureInfo}
        figureInfoKey={figureInfoKey}
      />
    ))}
  </Box>
)
